module.exports = __webpack_public_path__ + "static/Luana-Gomes-654c36c3b12f9e4f61719380d4a35db7.jpg";